import React, { useState, useEffect } from "react";
import { motion, useScroll, useTransform, useSpring } from "framer-motion";
import { FiChevronUp } from "react-icons/fi";
import "./ScrollProgressButton.css";

export default function ScrollProgressButton({ threshold = 0.06 }) {
  const { scrollYProgress } = useScroll();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 520);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const radius = isMobile ? 18 : 22;
  const circumference = 2 * Math.PI * radius;
  const svgSize = isMobile ? 48 : 56;
  const center = svgSize / 2;
  const iconSize = isMobile ? 16 : 18;

  const raw = useTransform(scrollYProgress, [0, 1], [circumference, 0]);
  const dashOffset = useSpring(raw, { stiffness: 160, damping: 28 });

  const opacity = useTransform(scrollYProgress, [0, threshold, threshold + 0.04], [0, 0, 1]);
  const translateY = useTransform(scrollYProgress, [0, threshold, 1], [18, 6, 0]);

  const handleClick = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <motion.button
      className="scroll-progress-btn"
      onClick={handleClick}
      aria-label="Scroll to top"
      title="Scroll to top"
      style={{ opacity, translateY }}
    >
      <svg 
        className="progress-ring" 
        width={svgSize} 
        height={svgSize} 
        viewBox={`0 0 ${svgSize} ${svgSize}`} 
        aria-hidden="true"
      >
        <defs>
          <linearGradient id="gradPink" x1="0" x2="1">
            <stop offset="0%" stopColor="#ffc3da" />
            <stop offset="100%" stopColor="#ff94c2" />
          </linearGradient>
        </defs>

        <circle
          className="ring-bg"
          cx={center}
          cy={center}
          r={radius}
          stroke="#fff3f6"
          strokeWidth="4"
          fill="none"
        />

        <motion.circle
          className="ring-progress"
          cx={center}
          cy={center}
          r={radius}
          stroke="url(#gradPink)"
          strokeWidth="4"
          strokeLinecap="round"
          fill="none"
          strokeDasharray={circumference}
          style={{ strokeDashoffset: dashOffset }}
          transform={`rotate(-90 ${center} ${center})`}
        />
      </svg>

      <span className="icon-inner" aria-hidden="true">
        <FiChevronUp size={iconSize} />
      </span>
    </motion.button>
  );
}

